import { PagedSearch } from 'src/app/shared';

export class CommitteeMeetingSearchDto extends PagedSearch {
  CommitteeID: number;
  FromDate: Date;
  ToDate: Date;
}
